import React, { useEffect, useState } from "react";
import moment from "moment";
import "react-dates/initialize";
import {
  DateRangePicker,
  SingleDatePicker,
  isInclusivelyBeforeDay,
  isInclusivelyAfterDay
} from "react-dates";
import "react-dates/lib/css/_datepicker.css";

const ReactDatePicker = ({
  startDate,
  endDate,
  minDate,
  maxDate,
  updateDates,
  isRangePicker,
  calendarEndDate,
  numberOfMonths,
  firstDataDate,
  showDefaultInputIcon,
  disabled = false,
  showClearDate = false,
  allowAllDays = false
}) => {
  // const [startDateState, setStartDateState] = useState(startDate ? moment(startDate) : null);

  const startDateState = startDate ? moment(startDate) : null;
  const [endDateState, setEndDateState] = useState(moment(endDate));
  const [initVisibleMonth, setInitVisibleMonth] = useState(moment(endDate));
  const [focusedInput, setFocusedInput] = useState(null);
  const [focused, setFocused] = useState(false);

  // useEffect(() => {
  //   setStartDateState(moment(startDate));
  // }, [startDate]);

  useEffect(() => {
    setEndDateState(moment(endDate));
  }, [endDate]);

  const dateChange = (startDate, endDate) => {
    if (startDate !== null && endDate !== null) {
      updateDates(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"));
    }

    if (!isRangePicker && showClearDate && startDate == null) {
      updateDates(null);
    }
  };

  const renderCalendarInfo = () => {
    let formattedMinDate = "";
    const formattedMaxDate = maxDate ? maxDate : moment(calendarEndDate).format("MM/DD/YYYY");
    if (numberOfMonths) {
      formattedMinDate = moment(calendarEndDate).subtract(numberOfMonths, "month");
    } else if (minDate) {
      formattedMinDate = moment(minDate);
    } else if (firstDataDate) {
      formattedMinDate = moment(firstDataDate);
    }

    formattedMinDate = formattedMinDate && formattedMinDate.format("MM/DD/YYYY");
    return minDate ? (
      <div style={{ color: "white", padding: "10px", fontWeight: "bold" }}>
        <span className="glyphicon glyphicon-info-sign" />
        {` Date should be in range: ${formattedMinDate} - ${formattedMaxDate}`}
      </div>
    ) : (
      ""
    );
  };

  const doFocusChange = (type) => {
    if (type === "endDate") {
      setInitVisibleMonth(moment(endDate));
    } else if (type === "startDate") {
      setInitVisibleMonth(moment(startDate));
    }
  };

  const isOutsideRange = (day) => {
    let calc;
    if (allowAllDays) return false;
    if (minDate !== undefined) {
      calc = day.isBefore(moment(minDate), "day") || day.isAfter(moment(calendarEndDate), "day");
    } else if (numberOfMonths !== undefined) {
      calc =
        !isInclusivelyBeforeDay(day, moment(calendarEndDate)) ||
        !isInclusivelyAfterDay(day, moment(calendarEndDate).subtract(numberOfMonths, "month"));
    } else if (firstDataDate !== undefined) {
      calc =
        !isInclusivelyBeforeDay(day, moment(calendarEndDate)) ||
        !isInclusivelyAfterDay(day, moment(firstDataDate));
    } else {
      calc = !isInclusivelyBeforeDay(day, moment(calendarEndDate));
    }

    return calc;
  };

  return (
    <div>
      {isRangePicker ? (
        <DateRangePicker
          calendarInfoPosition="top"
          renderCalendarInfo={renderCalendarInfo}
          startDate={startDateState}
          startDateId="your_unique_start_date_id"
          endDate={endDateState}
          endDateId="your_unique_end_date_id"
          onDatesChange={({ startDate, endDate }) => dateChange(startDate, endDate)}
          focusedInput={focusedInput}
          onFocusChange={(focusedInput) => {
            doFocusChange(focusedInput), setFocusedInput(null);
            // hack to re-render the calendar at correct month based on date click.
            setTimeout(() => {
              setFocusedInput(focusedInput);
            }, 1);
          }}
          initialVisibleMonth={() => initVisibleMonth}
          showDefaultInputIcon={showDefaultInputIcon}
          isOutsideRange={isOutsideRange}
          minimumNights={0}
          disabled={disabled}
        />
      ) : (
        <SingleDatePicker
          calendarInfoPosition="top"
          renderCalendarInfo={renderCalendarInfo}
          date={startDateState}
          onDateChange={(date) => dateChange(date, date)}
          focused={focused}
          onFocusChange={({ focused }) => setFocused(focused)}
          id="your_unique_id"
          showDefaultInputIcon={showDefaultInputIcon ?? true}
          isOutsideRange={isOutsideRange}
          disabled={disabled}
          showClearDate={showClearDate}
        />
      )}
    </div>
  );
};

export default React.memo(ReactDatePicker);
